// Communication - compose email
export const CheckboxGroup = ({ options, input, meta }) => {
  return (
    <div className="d-flex justify-content-between flex-xxl-row flex-column">
      {options.map(option => (
        <div className="form-check" key={option.value}>
          <label className="form-check-label">
            <input
              className="form-check-input"
              type="checkbox"
              name={option.label}
              checked={input.value.indexOf(option.label) !== -1}
              onChange={event => {
                const newValue = [...input.value]
                if (event.target.checked && option.label === "Pending users") {
                  if (
                    newValue.includes("All users in app (active users only)")
                  ) {
                    newValue.push(option.label)
                  } else {
                    return input.onChange([option.label])
                  }
                } else if (
                  event.target.checked &&
                  option.label === "All users in app (active users only)"
                ) {
                  if (newValue.includes("Pending users")) {
                    newValue.push(option.label)
                  } else {
                    return input.onChange([option.label])
                  }
                } else if (event.target.checked) {
                  return input.onChange([option.label])
                } else {
                  newValue.splice(newValue.indexOf(option.label), 1)
                }
                return input.onChange(newValue)
              }}
            />
            {option.label}
          </label>
        </div>
      ))}
    </div>
  )
}
